<template>
  <v-dialog
    overlay-opacity="0.9"
    overlay-color="black"
    :value="dialog"
    @click:outside="close()"
  >
    <v-row align="center" justify="center" class="d-flex d-sm-none">
      <v-spacer />
      <v-col cols="1">
        <v-icon
          color="white"
          x-large
          @click="previous()"
          :disabled="selected === 0"
        >
          mdi-chevron-left
        </v-icon>
      </v-col>
      <v-spacer />
      <v-col cols="1">
        <v-btn
          color="white"
          class="ma-2"
          text
          icon
          top
          right
          absolute
          large
          @click="close(false)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-icon
          color="white"
          x-large
          @click="next()"
          :disabled="selected === data.length - 1"
        >
          mdi-chevron-right
        </v-icon>
      </v-col>
      <v-spacer />
    </v-row>

    <v-row align="center" justify="center" class="ma-0 pa-0">
      <v-col cols="1" class="d-none d-sm-flex">
        <v-icon
          color="white"
          x-large
          @click="previous()"
          :disabled="selected === 0"
        >
          mdi-chevron-left
        </v-icon>
      </v-col>

      <v-col cols="10" class="white--text">
        <v-img contain max-height="80vh" :src="data[selected].link" />
      </v-col>

      <v-col cols="1" align="end" class="d-none d-sm-flex">
        <v-btn
          color="white"
          class="ma-2"
          text
          icon
          top
          right
          absolute
          large
          @click="close(false)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-icon
          color="white"
          x-large
          @click="next()"
          :disabled="selected === data.length - 1"
        >
          mdi-chevron-right
        </v-icon>
      </v-col>
    </v-row>
    <v-row>
      <v-spacer />

      <v-col cols="10" class="white--text text-center text-h6">
        {{ data[selected].title }}
      </v-col>

      <v-spacer />
    </v-row>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters({
      dialog: "galleryDialog",
      data: "galleryData",
      selected: "gallerySelected"
    })
  },

  methods: {
    ...mapMutations({
      close: "SET_GALLERY_DIALOG"
    }),
    previous() {
      if (this.selected > 0) {
        this.$store.commit("SET_GALLERY_SELECTED", --this.selected);
      }
    },
    next() {
      if (this.selected < this.data.length - 1) {
        this.$store.commit("SET_GALLERY_SELECTED", ++this.selected);
      }
    }
  }
};
</script>

<style></style>
